import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="test-smtp-connection"
export default class extends Controller {
  static values = {
    testPath: String,
    testingLabel: String,
    successLabel: String,
    errorFallbackLabel: String,
  }

  static targets = [
    "domainInput",
    "addressInput",
    "portInput",
    "userInput",
    "passwordInput",
    "authenticationInput",
    "starttlsInput",
    "feedbackOutput",
    "button",
  ]

  declare testPathValue: string
  declare testingLabelValue: string
  declare successLabelValue: string
  declare errorFallbackLabelValue: string
  declare domainInputTarget: HTMLInputElement
  declare addressInputTarget: HTMLInputElement
  declare portInputTarget: HTMLInputElement
  declare userInputTarget: HTMLInputElement
  declare passwordInputTarget: HTMLInputElement
  declare authenticationInputTarget: HTMLSelectElement
  declare starttlsInputTarget: HTMLInputElement
  declare feedbackOutputTarget: HTMLOutputElement
  declare buttonTarget: HTMLButtonElement

  async testConnection() {
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

    this.feedbackOutputTarget.classList.remove("text-danger-subtle", "text-success-subtle")
    this.feedbackOutputTarget.textContent = this.testingLabelValue
    this.buttonTarget.disabled = true

    try {
      const res = await fetch(this.testPathValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken || "",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          site_email_domain: {
            domain: this.domainInputTarget.value,
            smtp_address: this.addressInputTarget.value,
            smtp_port: this.portInputTarget.value,
            smtp_user: this.userInputTarget.value,
            smtp_password: this.passwordInputTarget.value,
            smtp_authentication: this.authenticationInputTarget.value,
            smtp_enable_starttls_auto: this.starttlsInputTarget.checked,
          },
        }),
      })

      const data = await res.json()
      if (res.ok && data.success) {
        this.renderFeedbackSuccess()
      } else {
        this.renderFeedbackError(data.error || this.errorFallbackLabelValue)
      }
    } catch (e) {
      this.renderFeedbackError(e.message)
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  renderFeedbackSuccess() {
    this.feedbackOutputTarget.classList.add("text-success-subtle")
    this.feedbackOutputTarget.textContent = this.successLabelValue
  }

  renderFeedbackError(error: string) {
    this.feedbackOutputTarget.classList.add("text-danger-subtle")
    this.feedbackOutputTarget.textContent = error
  }
}
